import React, { FunctionComponent, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../Redux/Store/Hooks";
import { useDispatch } from "react-redux";
import { listUser } from "../Redux/Slices/User/ListUserSlice";
import SessionExpiredDialog from "../Components/SessionExpired/SessionExpired";
import { sessionExpired } from "../Redux/Slices/SessionExpired/SessionExpired";
import NetworkStatus from "../Components/NetworkStatus/NetworkStatus";

interface AuthRouteProps {
  element?: React.ReactNode;
}

const AuthRoute: FunctionComponent<AuthRouteProps> = ({ element }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { data, error } = useAppSelector((state) => state.ListUserSlice);

  const hasToken = !!sessionStorage.getItem("token");

  const isApiUnauthorized =
    data?.message === "Request failed with status code 401" ||
    error?.response?.status === 401;

  useEffect(() => {
    if (hasToken) {
      dispatch(listUser());
    }
  }, [dispatch, hasToken]);

  useEffect(() => {
    if (isApiUnauthorized && hasToken) {
      sessionStorage.setItem(
        "redirectAfterLogin",
        location.pathname + location.search
      );
      dispatch(sessionExpired(true));
    }
  }, [isApiUnauthorized, hasToken, dispatch, location]);

  if (!hasToken) {
    sessionStorage.setItem(
      "redirectAfterLogin",
      location.pathname + location.search
    );

    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <SessionExpiredDialog />
      <NetworkStatus />
      {element ?? <Outlet />}
    </>
  );
};

export default AuthRoute;
